import { Theme } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid-pro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import { ITranslationManager } from "@fenetech/translations";
import { IDashboardRMA } from "helpers/interfaces";
import ApiUser from "models/ApiUser";

export const generateRMAColumns = (tm: ITranslationManager, data: IDashboardRMA[] | undefined, theme: Theme, isMobile: boolean, user: ApiUser) => {

  if (!data || data.length === 0) return [] as GridColumns;

  const generator = new DataGridColumnGenerator(tm, data, theme, isMobile);

  generator.TryAddTextColumn("rmaNumber", "RMA", { hideable: false });
  generator.TryAddDateColumn("date", "Date", {});
  generator.TryAddTextColumn("customerRef", "Customer Ref", {});
  generator.TryAddDateColumn("expirationDate", "Expires", {});
  generator.TryAddTextColumnWithTooltip("statusBasic", "Status", { tooltip: "{0}", tooltipParams: ["statusAdvanced"] }, {});
  if (user.isMultiSite) {
    generator.TryAddTextColumn("mfgSiteName", "Mfg Customer", {});
  }

  return generator.GetColumns();
}
